<template>
  <div>
    <topbar/>

    <div class="container">
      <h1 class="mt-5">Projects statistics</h1>
      <div class="row">
        <div class="col-sm-6 py-1">
          <div class="card">
            <div class="card-body">
              <canvas ref="phases_chart" id="phases_chart" width="500" height="500"></canvas>
            </div>
          </div>
        </div>
        <div class="col-6 py-5">
          <div class="row">
            <div class="card">
              <div class="card-body">
                <canvas ref="bar_chart1" id="bar_chart1"></canvas>
              </div>
            </div>
          </div>
          <div class="row py-5">
            <div class="card">
              <div class="card-body">
                <canvas ref="bar_chart2" id="bar_chart2"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Chart from 'chart.js'
import Topbar from '../components/Topbar'
export default {
  name: 'Projects',
  components: { Topbar },
  mounted () {
    this.axios.get(this.$serverAddr + '/statistics').then((response) => {
      this.dataLoaded(response.data)
    })
  },
  data () {
    return {
      projects: []
    }
  },
  methods: {
    dataLoaded (data) {
      var colors = [
        '#007bff',
        '#6610f2',
        '#6f42c1',
        '#e83e8c',
        '#dc3545',
        '#fd7e14',
        '#ffc107',
        '#28a745',
        '#20c997',
        '#17a2b8',
        '#6c757d',
        '#343a40',
        '#007bff',
        '#6c757d',
        '#28a745',
        '#17a2b8',
        '#ffc107',
        '#dc3545',
        '#343a40'
      ]
      var phases_chart = this.$refs["phases_chart"];

      var phases_chart_options = {
        title: {
          display: true,
          text: 'Project phases'
        },
        legend: { position: 'bottom', padding: 2, labels: { pointStyle: 'circle', usePointStyle: true } }
      };
      var phases_chart_data = {
        labels: [
          "Open",
          "Specified",
          "Waiting",
          "Approved",
          "In progress",
          "In verification",
          "Verified",
          "Closed",
          "Canceled"
        ],
        datasets: [
          {
            backgroundColor: colors.slice(0, 11),
            borderWidth: 0,
            data: Object.values(data.phases)
          }
        ]
      }

      var bar_chart1_options = {
        title: {
          display: true,
          text: 'Time spent on projects'
        },
        legend: { display: false },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Time in days'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Project'
            }
          }]
        }
      };

      var bar1_chart_data = {
        labels: Object.keys(data.projects),
        datasets: [
          {
            backgroundColor: colors.slice(0, 11),
            borderWidth: 0,
            data: Object.keys(data.projects).map(k => data.projects[k].time)
          }
        ]
      };

      var bar2_chart_data = {
        labels: Object.keys(data.projects),
        datasets: [
          {
            backgroundColor: colors.slice(0, 11),
            borderWidth: 0,
            data: Object.keys(data.projects).map(k => data.projects[k].participants)
          }
        ]
      };

      var bar2_chart_options = {
        title: {
          display: true,
          text: 'Number of participants'
        },
        legend: { display: false },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Number of participants'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Project'
            }
          }]
        }
      };

      if (phases_chart) {
        new Chart(phases_chart, {
          type: 'pie',
          data: phases_chart_data,
          options: phases_chart_options
        });
      }

      var bar_chart1 = this.$refs["bar_chart1"];
      if (bar_chart1) {
        new Chart(bar_chart1, {
          type: 'bar',
          data: bar1_chart_data,
          options: bar_chart1_options
        });
      }

      var bar_chart2 = this.$refs["bar_chart2"];
      if (bar_chart2) {
        new Chart(bar_chart2, {
          type: 'bar',
          data: bar2_chart_data,
          options: bar2_chart_options
        });
      }
    }
  }
}
</script>
